import styled from 'styled-components';
import Icon, { ICON_INFO } from '../../icon';

export const InfoButtonContainer = styled.button`
	cursor: pointer;
	position: relative;
	top: -3px;
	right: -3px;
	margin-left: auto;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;

	opacity: 0.6;

	&:hover {
		opacity: 1;
	}

	&::before {
		background-color: #000;
		border-radius: 50%;
		width: 17px;
		height: 17px;
		content: '';
		position: absolute;
		z-index: -1;
	}

	& > svg {
		color: white;
	}
`;

const InfoButton = ({ onClick }) => {
	return (
		<InfoButtonContainer onClick={onClick}>
			<Icon type={ICON_INFO} width={20} height={20} />
		</InfoButtonContainer>
	);
};

export default InfoButton;
